export default {
      id: "txt_italic-usage",
      viewBox: "0 0 10 16",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#txt_italic",
      toString: function () {
        return this.url;
      }
    }